import { AppMessegerNewDialog } from '../../components/AppMessegerNewDialog';
import { AppMessengerDialog } from '../../components/AppMessengerDialog';
import { AppMessengerDialogsTab } from '../../components/AppMessengerDialogsTab';
import { MessengerStages } from '../../models/Messenger';
import { useLayoutSelector } from '../../redux';
import { StyledContainer } from './PhoneMessenger.styled';

const PhoneMessenger = () => {
	const activeMessengerState = useLayoutSelector(
		(state) => state.messenger.activeMessengerState,
	);
	return (
		<StyledContainer>
			{activeMessengerState === MessengerStages.DIALOGS && (
				<AppMessengerDialogsTab />
			)}
			{activeMessengerState === MessengerStages.DIALOG && (
				<AppMessengerDialog />
			)}
			{activeMessengerState === MessengerStages.NEW_DIALOG && (
				<AppMessegerNewDialog />
			)}
		</StyledContainer>
	);
};

export { PhoneMessenger };
